module.exports = __webpack_public_path__ + "img/index_ligth.0a1518fe.png";